import styled from "styled-components";

export const DealerContainer = styled.div`
  padding: 32px 0;
  .item {
    background: #fff;
    border: solid 1px ${({ theme }) => theme.colors.lightFont};
    margin: 16px 0;
    border-radius: 10px;
    cursor: pointer;
    padding: 16px;
    position: relative;
    .text,
    .province-city {
      font-weight: bold;
    }
    &:hover {
      border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
    }
    .checked {
      display: none;
      color: ${({ theme }) => theme.colors.btnPrimaryBg};
      font-size: 48px;
      position: absolute;
      left: 8px;
      top: calc(50% - 24px);
    }
  }
  .not-allowed {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .selected {
    border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
    cursor: default;
    .checked {
      display: block;
    }
  }
  .buttons {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
  }
`;
